import { Search, Filter, X } from "lucide-react";

export default function SearchBar({ query, setQuery, filterStatus, setFilterStatus }) {
  const handleClear = () => {
    setQuery('');
  };

  const handleFilterClick = (filter) => {
    const filterMap = {
      'All Stores': 'all',
      'Clean': 'clean',
      'Errors': 'error',
      'Pending': 'pending'
    };
    setFilterStatus(filterMap[filter]);
  };

  return (
    <div className="max-w-2xl mx-auto">
      <div className="relative">
        <div className={`
          flex items-center gap-4 p-4 rounded-2xl border-2 transition-all duration-300
          focus-within:border-white shadow-lg
          ${query ? 'border-white bg-white' : 'border-white/30 bg-white/20'}
          backdrop-blur-md
        `}>
          {/* Search Icon */}
          <div className="flex-shrink-0">
            <Search
              size={24}
              className={`transition-colors duration-200 ${query ? 'text-[#cc5500]' : 'text-white'
                }`}
            />
          </div>

          {/* Input Field */}
          <input
            type="text"
            value={query}
            onChange={e => setQuery(e.target.value)}
            placeholder="Search stores by name, region, or status..."
            className={`flex-1 bg-transparent outline-none text-lg font-medium focus-ring ${query ? 'text-slate-900 placeholder-slate-400' : 'text-white placeholder-white/80'
              }`}
          />

          {/* Clear Button */}
          {query && (
            <button
              onClick={handleClear}
              className="flex-shrink-0 p-2 rounded-full transition-all duration-200 hover:scale-110 bg-orange-100 text-[#cc5500] hover:bg-[#cc5500] hover:text-white"
              aria-label="Clear search"
            >
              <X size={16} />
            </button>
          )}

          {/* Filter Button */}
          <button
            className={`flex-shrink-0 p-2 rounded-full transition-all duration-200 hover:scale-110 ${query ? 'bg-orange-100 text-[#cc5500] hover:bg-[#cc5500] hover:text-white' : 'bg-white/20 text-white hover:bg-white/30'
              }`}
            aria-label="Filter options"
          >
            <Filter size={16} />
          </button>
        </div>

        {/* Search Suggestions/Results Counter */}
        {query && (
          <div className="absolute top-full left-0 right-0 mt-2 p-3 rounded-xl animate-fade-in bg-white border border-slate-200 shadow-modern">
            <div className="flex items-center gap-2 text-sm">
              <Search size={14} className="text-[#cc5500]" />
              <span className="text-slate-600">
                Searching for "{query}"
              </span>
            </div>
          </div>
        )}
      </div>

      {/* Quick Filters */}
      <div className="flex flex-wrap gap-3 mt-4 justify-center">
        {['All Stores', 'Clean', 'Errors', 'Pending'].map((filter) => {
          const filterMap = {
            'All Stores': 'all',
            'Clean': 'clean',
            'Errors': 'error',
            'Pending': 'pending'
          };
          const isActive = filterStatus === filterMap[filter];

          return (
            <button
              key={filter}
              onClick={() => handleFilterClick(filter)}
              className={`
                px-6 py-2.5 rounded-full text-sm font-semibold transition-all duration-200
                hover:scale-105 border shadow-sm hover:shadow-md
                ${isActive
                  ? 'bg-white text-[#cc5500] border-white hover:bg-white/90 ring-2 ring-white/50'
                  : 'bg-white/20 text-white border-white/30 hover:bg-white hover:text-[#cc5500] hover:border-white backdrop-blur-md'
                }
              `}
            >
              {filter}
            </button>
          );
        })}
      </div>
    </div>
  );
}
